import React from "react";
import DateControl from "./Date";
import TimeControl from "./Time";

// If timeZoneName is undefined, it will just use the browser's timezone
export default class DateTimeControl extends React.PureComponent {
  getInitialValue() {
    const {
      timeZoneName = moment.defaultZone && moment.defaultZone.name,
      value,
      initialTime = "00:00",
      initialValue = value ||
        moment.tz(initialTime, moment.TIME_FORMAT, timeZoneName).format(moment.RUBY_DATETIME_FORMAT),
    } = this.props;
    return initialValue;
  }

  handleDateChange(nextDate) {
    const { timeZoneName = moment.defaultZone && moment.defaultZone.name, onChange, value } = this.props;
    const initialValue = this.getInitialValue();
    if (!onChange) {
      return;
    }
    if (!nextDate) {
      return onChange(null);
    }
    const nextM = moment.tz(nextDate, moment.RUBY_DATE_FORMAT, timeZoneName);
    const nextValue = moment
      .tz(value || initialValue, timeZoneName)
      .set({
        year: nextM.year(),
        month: nextM.month(),
        date: nextM.date(),
      })
      .format(moment.RUBY_DATETIME_FORMAT);
    onChange(nextValue);
  }

  handleTimeChange(nextTime) {
    const { timeZoneName = moment.defaultZone && moment.defaultZone.name, onChange, value } = this.props;
    const initialValue = this.getInitialValue();
    if (!onChange) {
      return;
    }
    if (!nextTime) {
      return onChange(null);
    }
    const nextM = moment.tz(nextTime, moment.TIME_FORMAT, timeZoneName);
    const nextValue = moment
      .tz(value || initialValue, timeZoneName)
      .set({
        hour: nextM.hour(),
        minute: nextM.minute(),
        second: 0,
        millisecond: 0,
      })
      .format(moment.RUBY_DATETIME_FORMAT);
    onChange(nextValue);
  }

  render() {
    const {
      timeZoneName = moment.defaultZone && moment.defaultZone.name,
      id = "DateTimeControl",
      value,
      initialTime,
      initialValue,
      onChange,
      disabled,
      className,
      ...rest
    } = this.props;

    return (
      <span className={"DateTimeControl field inline " + (className || "")}>
        <DateControl
          id={`${id}-date`}
          value={value ? moment.tz(value, timeZoneName).format(moment.RUBY_DATE_FORMAT) : value}
          onChange={onChange && this.handleDateChange.bind(this)}
          disabled={disabled}
          {...rest}
        />

        <TimeControl
          id={`${id}-time`}
          value={value ? moment.tz(value, timeZoneName).format(moment.TIME_FORMAT) : value}
          onChange={onChange && this.handleTimeChange.bind(this)}
          disabled={disabled || !value}
          {...rest}
        />
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/DateTime.jsx